import colors from 'style-utils/colors';

const trisTitleTheme = {
  trisTitle: {
    mobile: {
      padding: '16px 0 16px',
      overline: {
        color: colors.greenLight,
        fontWeight: 600,
        fontSize: '12px',
        letterSpacing: '0.24px',
        lineHeight: '18px',
      },
      title: {
        color: colors.black,
        fontWeight: 800,
        fontSize: '24px',
        letterSpacing: '0.48px',
        lineHeight: '28px',
      },
      subtitle: {
        color: colors.blackTwelve,
        fontWeight: 400,
        fontSize: '12px',
        letterSpacing: '0.24px',
        lineHeight: '14px',
        margin: '4px 0 0',
      },
    },
    desktop: {
      padding: '30px 0 24px',
      overline: {
        color: colors.greenLight,
        fontWeight: 600,
        fontSize: '14px',
        letterSpacing: '0.28px',
        lineHeight: '18px',
      },
      title: {
        color: colors.black,
        fontWeight: 800,
        fontSize: '24px',
        letterSpacing: '0.48px',
        lineHeight: '28px',
      },
      subtitle: {
        color: colors.black,
        fontWeight: 400,
        fontSize: '14px',
        letterSpacing: '0.28px',
        lineHeight: '18px',
        margin: '4px 0 0',
      },
    },
  },
};

export default trisTitleTheme;
